import React from 'react';

export default function MetricsBar({ metrics, pipeline, filters, onChange }) {
  const isInvestor = pipeline === 'Investor';

  const cards = isInvestor ? [
    { key: 'total',        label: 'Total',        color: 'var(--primary)' },
    { key: 'active',       label: 'Active',        color: 'var(--success)', field: 'status',   value: 'Active' },
    { key: 'high_prio',    label: 'High Priority', color: 'var(--warning)', field: 'priority', value: 'High' },
    { key: 'overdue',      label: 'Overdue',       color: 'var(--overdue)', field: 'overdue',  value: true },
    { key: 'term_sheets',  label: 'Term Sheets',   color: '#A78BFA',        field: 'stage',    value: 'Term Sheet' },
    { key: 'closed',       label: 'Closed',        color: '#34D399',        field: 'stage',    value: 'Closed' },
  ] : [
    { key: 'total',           label: 'Total',          color: 'var(--primary)' },
    { key: 'active',          label: 'Active',          color: 'var(--success)', field: 'status',   value: 'Active' },
    { key: 'high_prio',       label: 'High Priority',   color: 'var(--warning)', field: 'priority', value: 'High' },
    { key: 'overdue',         label: 'Overdue',         color: 'var(--overdue)', field: 'overdue',  value: true },
    { key: 'pilots',          label: 'In Pilot',        color: '#A78BFA',        field: 'stage',    value: 'Pilot' },
    { key: 'active_partners', label: 'Active Partners', color: '#34D399',        field: 'stage',    value: 'Active Partner' },
  ];

  const isCardActive = (c) => !!c.field && filters?.[c.field] === c.value;

  const EMPTY_FILTERS = { status: '', stage: '', priority: '', owner: '', overdue: false, search: '' };

  const handleClick = (c) => {
    if (!onChange) return;
    if (c.key === 'total') { onChange({ ...EMPTY_FILTERS }); return; }
    if (!c.field) return;
    const active = isCardActive(c);
    // Cards are primary filters: clicking one resets every other filter
    // (dropdowns + other cards) so a card always shows its full result set.
    onChange(active ? { ...EMPTY_FILTERS } : { ...EMPTY_FILTERS, [c.field]: c.value });
  };

  return (
    <div className="kpi-grid" style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: 10,
      margin: '20px 0 16px',
    }}>
      {cards.map(c => {
        const active = isCardActive(c);
        return (
          <div key={c.key} className="kpi-card" onClick={() => handleClick(c)} style={{
            background: active ? 'var(--bg-hover)' : 'var(--bg-card)',
            border: `1px solid ${active ? c.color : 'var(--border)'}`,
            borderRadius: 'var(--radius)',
            padding: '12px 16px',
            position: 'relative', overflow: 'hidden',
            cursor: (c.field || c.key === 'total') ? 'pointer' : 'default',
            transition: 'all 0.15s',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: c.color }} />
            <div className="kpi-num" style={{ fontFamily: 'Sora, sans-serif', fontSize: 26, fontWeight: 700, color: c.color, lineHeight: 1 }}>
              {metrics[c.key] ?? '—'}
            </div>
            <div className="kpi-label" style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 4, fontWeight: 500 }}>
              {c.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
